var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container d-flex justify-center align-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"50","color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }